import React, {useEffect} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from "../../context/auth";
import { store } from 'react-notifications-component';
import {ACL_ENABLE_ENDPOINTS, ACL_RESOURCE_ROUTES_MAP, USER_ACCESS_LEVEL} from "../../utils/constants";


const PrivateRouteWithLayout = props => {
    const { layout: Layout, component: Component, ...rest } = props;
    const { authToken, authUser } = useAuth();

    useEffect(()=> {
        if (!authUser) {
            store.addNotification({
                title: "Forbidden",
                message: "you are not authorized to access this page, \nPlease login using valid credentials!",
                type: "danger",
                insert: "bottom",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 2000,
                    showIcon: true
                }
            });
        }


        if (authUser && props.location.pathname !== '/auth/confirm/email') {
            if (!authUser.is_email_verified ) {
                store.addNotification({
                    title: "Email Not Verified",
                    message: "you are not a legitimate user in our system, please verify your email address first",
                    type: "danger",
                    insert: "bottom",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 2000,
                        showIcon: true
                    }
                });
            }
            if (!authUser.is_active) {
                store.addNotification({
                    title: "User not active",
                    message: "this user is not active yet, you need permission from developers, request access at dev@dqlab.net",
                    type: "danger",
                    insert: "bottom",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 2000,
                        showIcon: true
                    }
                });
            }

        }

    }, [authUser]);

    const isPermissible = (pathname) => {
        if (authUser && authUser.permissions) {
            if (authUser.access_level === USER_ACCESS_LEVEL.PARTIAL_ACCESS_ADMIN_PORTAL) {
                const allowed_perms = authUser.permissions;
                const path_parts = pathname.split('/');
                if (path_parts.length > 2) {
                    const effective_path = [path_parts[1], path_parts[2]].join('/');
                    if (ACL_ENABLE_ENDPOINTS.includes(effective_path)) {
                        const url_perm_key = ACL_RESOURCE_ROUTES_MAP[effective_path];
                        return !!(allowed_perms[url_perm_key] && allowed_perms[url_perm_key]["fullAccess"]);
                    }
                }


            }
        }
        return true
    }

    return (
        <Route
            {...rest}
            render={matchProps => (
                authToken && authUser ? (
                    authUser.is_email_verified || matchProps.location.pathname === '/auth/confirm/email' ? (
                            isPermissible(matchProps.location.pathname) ? <Layout>
                                <Component {...matchProps} />
                            </Layout> : <Redirect
                                to={{ pathname: "/", referer: matchProps.location}}
                            />
                        )
                     : <Redirect
                            to={{ pathname: "/auth/confirm/email", referer: matchProps.location}}
                        />
                ) : (() => {
                localStorage.setItem("document_viewer_redirect", matchProps.location.pathname + matchProps.location.search);
                return (
                <Redirect
                to={{ pathname: "/login", referer: matchProps.location}}
        />
    );
})()

)}
        />
    );

};

export default PrivateRouteWithLayout;
